import React from 'react';
// our components
import { RowLoader } from 'components/common/RowLoader';

/**
 * @description
 * Stateless component.
 *
 * @returns {undefined} - No returns value.
 */
export const TableLoader = () => (
  <React.Fragment>
    {Array(10)
      .fill('')
      .map((e, i) => (
        <RowLoader
          // eslint-disable-next-line react/no-array-index-key
          key={`row-${i}`}
          style={{ opacity: Number(2 / i).toFixed(1) }}
        />
      ))}
  </React.Fragment>
);

export default TableLoader;
